var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popin-notification",class:[_vm.color, { 'is-open': _vm.isOpen }],on:{"click":function($event){$event.preventDefault();return _vm.close.apply(null, arguments)}}},[_c('div',[(_vm.message)?_c('TextSimple',[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._t("default")],2),_c('SvgIcon',{attrs:{"name":"cross"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }